/* global frontendVars */

import scrollToElement from 'helpers/scroll/scrollTo';
import { trackEvent } from 'vendor/google/gtm/gtmEventTracker';

export const anchors = (function () {
    const _config = {
        productReviewsTab: () => {
            return document.querySelector('.collapse.product-reviews');
        },
        productReviewsAnchor: () => {
            return document.querySelector('#productpage-anchors [data-anchor=".product-reviews"]');
        },
        flowboxTab: () => {
            return document.querySelector('#flowbox-product-container');
        },
        flowboxAnchor: () => {
            return document.querySelector('#productpage-anchors [data-anchor="#flowbox-product-container"]');
        }
    };

    const _showFlowboxAnchor = () => {
        if (_config.flowboxTab() && _config.flowboxAnchor()) {
            _showAnchor(_config.flowboxAnchor());
        }
    };

    const _showReviewAnchor = () => {
        if (_config.productReviewsTab()) {
            _config.productReviewsTab().addEventListener('reviewsLoaded', () => {
                if (
                    _config.productReviewsTab() &&
                    _config.productReviewsAnchor() &&
                    !_config.productReviewsTab().classList.contains('d-none')
                ) {
                    _showAnchor(_config.productReviewsAnchor());
                }
            });
        }
    };

    const _showAnchor = (anchor) => {
        anchor.classList.remove('d-none');
        if (frontendVars.siteviewId === '1') {
            _sendAnchorTrackingEvents(anchor);
        }
    };

    const _addClickEventListeners = () => {
        // Loop through all anchors
        document.querySelector('#productpage-anchors').addEventListener('click', (e) => {
            const anchor = e.target.closest('#productpage-anchors li');
            const scrollElement = document.querySelector(anchor.dataset.anchor);

            e.preventDefault();
            _handleAnchorClick(scrollElement);
        });
    };

    const _handleAnchorClick = (el) => {
        if (el) {
            scrollToElement(el);

            // open element if needed
            if (el.classList.contains('collapse') && el.dataset.state !== 'open') {
                const content = el.querySelector('.collapse__content '); //Get content element
                content.style.maxHeight = content.scrollHeight + 'px';
                content.removeAttribute('inert');

                el.classList.add('c-open');
                el.setAttribute('data-state', 'open');
            }
        }
    };

    const _sendAnchorTrackingEvents = (anchor) => {
        const gtmCategory = anchor.getAttribute('data-gtm-category'); //Get category
        const gtmAction = anchor.getAttribute('data-gtm-action'); //Get action
        const gtmLabel = anchor.getAttribute('data-gtm-label'); //Get label
        trackEvent(gtmCategory, gtmAction, gtmLabel); //Send event to GA
    };

    const init = () => {
        _showFlowboxAnchor();
        _showReviewAnchor();
        _addClickEventListeners();
    };

    return {
        init
    };
})();
